module.exports = __webpack_public_path__ + "media/modals/arrow-248e107a.svg";